'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002424 from "./presto.-Dashboard-View$$anon$24.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dSign$002dStats$0024 from "./presto.types$-Dashboard-Sign-Stats$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$23() {
  this.aKE = null;
  this.aKw = null;
  this.aKx = false;
  this.aKF = null;
  this.aKG = false;
  this.aKJ = null;
  this.aKC = null;
  this.aKD = false;
  this.aKy = null;
  this.aKz = false;
  this.aKA = null;
  this.aKB = false;
  this.aKH = false;
  this.aKI = false;
  this.aKE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aKJ = "DashboardSignStats";
}
export { $c_Lpresto_DashboardView$$anon$23 as $c_Lpresto_DashboardView$$anon$23 };
$p = $c_Lpresto_DashboardView$$anon$23.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$23;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$23() {
}
export { $h_Lpresto_DashboardView$$anon$23 as $h_Lpresto_DashboardView$$anon$23 };
$h_Lpresto_DashboardView$$anon$23.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aKE;
});
$p.L = (function() {
  if ((!this.aKx)) {
    this.aKw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aKx = true;
  }
  return this.aKw;
});
$p.O = (function() {
  if ((!this.aKG)) {
    this.aKF = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aKG = true;
  }
  return this.aKF;
});
$p.E = (function() {
  return this.aKJ;
});
$p.t = (function() {
  if ((!this.aKD)) {
    this.aKC = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("signatures", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("envelopes", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aKD = true;
  }
  return this.aKC;
});
$p.M = (function() {
  if ((!this.aKz)) {
    this.aKy = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aKz = true;
  }
  return this.aKy;
});
$p.Q = (function() {
  if ((!this.aKB)) {
    this.aKA = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002424.$c_Lpresto_DashboardView$$anon$24();
    this.aKB = true;
  }
  return this.aKA;
});
$p.w = (function() {
  if ((!this.aKI)) {
    this.aKH = false;
    this.aKI = true;
  }
  return this.aKH;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee124) => ((p) => \u03b4scrutinee124.cGo(p)))($j_presto$002etypes$0024$002dDashboard$002dSign$002dStats$0024.$m_Lpresto_types$DashboardSignStats$())));
});
var $d_Lpresto_DashboardView$$anon$23 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$23, "presto.DashboardView$$anon$23", ({
  GO: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$23 as $d_Lpresto_DashboardView$$anon$23 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$23.js.map
